import { Row } from '@fs/zion-ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { usePageTitle } from '../../app/PageTitleContext'
import GroupReservationsTable from './GroupReservationsTable'
import ShareReservationsButton from './ShareReservationsButton'
import UnshareGroupReservationsButton from './UnshareGroupReservationsButton'
import useGroupReservations from './useGroupReservations'

export default function GroupReservations() {
  usePageView({ page_detail: 'DMConsole:GroupReservations' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.group.reservations'))
  const [groupReservationsState, helpers] = useGroupReservations()
  const [checkedRanIds, setCheckedRanIds] = useState([])

  return (
    <>
      <Row alignY="middle">
        <ShareReservationsButton
          refetchReservations={helpers.refetchReservations}
          growX={!(checkedRanIds.length > 0)}
        />
        {checkedRanIds.length > 0 && (
          <UnshareGroupReservationsButton
            checkedRanIds={checkedRanIds}
            refetchReservations={helpers.refetchReservations}
            growX
          />
        )}
        <span id="Group Reservations Total">{`${t('group.reservations.total', 'Total')}: ${
          groupReservationsState.reservations?.length
        }`}</span>
      </Row>
      <br />
      {groupReservationsState.reservations?.length > 0 ? (
        <GroupReservationsTable
          setCheckedRanIds={setCheckedRanIds}
          reservations={groupReservationsState.reservations}
          personData={groupReservationsState.personData}
          userNames={groupReservationsState.userNames}
        />
      ) : (
        t('groupReservations.notFound', 'Group reservations not found.')
      )}
    </>
  )
}
